import { FETCH_DCDD_MEMBERSHIP } from "../graphql/query";
import { actionTypes, CreateDcddMembershipPlanInput, DcddMembershipPlanProp, UpdateDcddMembershipPlanInput } from "./actionType";
import { CREATE_DCDD_MEMBERSHIP_PLAN_PLAN, UPDATE_DCDD_MEMBERSHIP_PLAN_PLAN, UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_PLAN } from "../graphql/mutation";
import { showSnackbar } from "utils/snack_bar/store/action";
import { executeMutation, executeQuery } from "utils/services/apiServices";

export const fetchDcddMembershipRequest = () => ({
    type: actionTypes.FETCH_DCDD_MEMBERSHIP_REQUEST
});

export const fetchDcddMembershipSuccess = (payload: DcddMembershipPlanProp[]) => ({
    type: actionTypes.FETCH_DCDD_MEMBERSHIP_SUCCESS,
    payload
});

export const fetchDcddMembershipFail = (payload: string) => ({
    type: actionTypes.FETCH_DCDD_MEMBERSHIP_FAIL,
    payload
});

export const fetchDcddMembership = () => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchDcddMembershipRequest());
            const response = await executeQuery(FETCH_DCDD_MEMBERSHIP);
            const jsonData = response.data?.fetchDcddMembership;
            if (jsonData?.error === null) {
                dispatch(fetchDcddMembershipSuccess(jsonData?.data.user_membership));
            } else {
                dispatch(fetchDcddMembershipFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchDcddMembershipFail('Failed to fetch dcdd membership'));
        }
    };
};

//create package
export const createDcddMembershipSuccess = (payload: DcddMembershipPlanProp) => ({
    type: actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_SUCCESS,
    payload
});
export const createDcddMembershipFail = (payload: string) => ({
    type: actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_FAIL,
    payload
});

export const createDcddMembership = (createDcddMembershipInput: CreateDcddMembershipPlanInput) => {
    return async (dispatch: any) => {
        try {
            const response = await executeMutation(CREATE_DCDD_MEMBERSHIP_PLAN_PLAN,createDcddMembershipInput);
            const jsonData = response.data?.dcddCreateMembershipPlan;
            if (jsonData?.error === null) {
                dispatch(createDcddMembershipSuccess(jsonData?.data.user_membership));
                dispatch(showSnackbar('Success! DcddMembership created.'));
            } else {
                dispatch(createDcddMembershipFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Fail to create. Error: ${jsonData?.error.message ? jsonData?.error.message: "Something went wrong" }`));
            }
        } catch (error: any) {
            dispatch(createDcddMembershipFail('Something went wrong, Try again later'))
        }
    };
};

//update package
export const updateDcddMembershipsSuccess = (payload: DcddMembershipPlanProp) => ({
    type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_SUCCESS,
    payload
});
export const updateDcddMembershipsFail = (payload: string) => ({
    type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_FAIL,
    payload
});

export const updateDcddMembership = (input: UpdateDcddMembershipPlanInput) => {
    return async (dispatch: any) => {
        try {
            const response = await executeMutation(UPDATE_DCDD_MEMBERSHIP_PLAN_PLAN,input);
            const jsonData = response.data?.dcddUpdateMembershipPlan;
            if (jsonData?.error === null) {
                dispatch(updateDcddMembershipsSuccess(jsonData?.data.user_membership));
                dispatch(showSnackbar('Success! DcddMembership created.'));
            } else {
                dispatch(updateDcddMembershipsFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Fail to update. Error: ${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`));
            }
        } catch (error: any) {
            dispatch(updateDcddMembershipsFail('Something went wrong, Try again later'))
        }
    };
};
//update package
export const updateDcddMembershipStatusSuccess = (payload: DcddMembershipPlanProp) => ({
    type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_SUCCESS,
    payload
});
export const updateDcddMembershipStatusFail = (payload: string) => ({
    type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_FAIL,
    payload
});

export const updateDcddMembershipStatus = (MembershipId: string) => {
    return async (dispatch: any) => {
        try {
            const response = await executeMutation(UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_PLAN,{ id: MembershipId });
            const jsonData = response.data?.UpdateUserMembershipStatus;
            if (jsonData?.error === null) {
                dispatch(updateDcddMembershipStatusSuccess(jsonData?.data.user_membership));
                dispatch(showSnackbar('Success! DcddMembership status created.'));
            } else {
                dispatch(updateDcddMembershipStatusFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Fail to update. Error: ${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`));
            }
        } catch (error: any) {
            dispatch(updateDcddMembershipStatusFail('Something went wrong, Try again later'))
        }
    };
};